import { render, staticRenderFns } from "./SellerRateInformation.vue?vue&type=template&id=2940ae85&lang=pug&"
import script from "./SellerRateInformation.vue?vue&type=script&lang=js&"
export * from "./SellerRateInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports